import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xpcb942eab: FaireBrandEntity = {
  token: "b_xpcb942eab",
  type: "brand",
  name: "Hello Aromas",
  avatarUrl:
    "https://cdn.faire.com/fastly/cda26c380c6305779c29a0d4c9fbedc6b1d191d62d34870f187478ff0a0d69e4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/aa5bb026bdc52fc21c534cd2c1f4f28f5a22812f0a2a6a2de5691601c9ed7891.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cda26c380c6305779c29a0d4c9fbedc6b1d191d62d34870f187478ff0a0d69e4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aa5bb026bdc52fc21c534cd2c1f4f28f5a22812f0a2a6a2de5691601c9ed7891.png",
  location: "Miami, FL, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description:
    "Hello Aromas – Our Story\nAt Hello Aromas, we believe that scent has the power to transform any space into an unforgettable experience. What began as a passion for fine fragrances has grown into a collection of premium cold-air diffusers and fragrance oils, designed to bring the luxury of high-end hotels and spas into homes and businesses around the world.\nEach of our oils is carefully crafted in the USA, using only the highest-quality ingredients that are safe, phthalate-free, and inspired by destinations that awaken the senses—like the Riviera, Belize, and beyond. Our diffusers blend innovation with design, offering Bluetooth scheduling, HVAC integration, and whisper-quiet performance, making it effortless to enjoy fragrance in everyday life.\nFrom boutique hotels and offices to family homes and personal sanctuaries, Hello Aromas creates moments of comfort, elegance, and connection—one breath at a time.\nHello Aromas. Elevate your space, awaken your senses.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.448Z",
    importedBy: "entity-db-cli",
  },
};
